module.exports = __webpack_public_path__ + "static/img/2.404de80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/2.png
// module id = bAn2
// module chunks = 0